import { useState } from "react";
import { ElImageForm } from "../../components/ui/display/ElImageForm";
import { UnifiedImageModal } from "../../components/ui/display/ImageViewer";

export default function ElImageViewerPage() {
  const [imageUrl, setImageUrl] = useState<string>("");
  const [open, setOpen] = useState(false);

  const handleImageLoad = (url: string) => {
    setImageUrl(url);
    setOpen(true);
  };

  const handleClose = () => {
    setImageUrl("");
    setOpen(false);
  };

  return (
    <>
      <ElImageForm setImageUrl={handleImageLoad} setOpen={setOpen} />

      {imageUrl && (
        <UnifiedImageModal
          open={open}
          onClose={handleClose}
          imageSrc={imageUrl}
          variant="modal"
          data-testid="el-modal"
        />
      )}
    </>
  );
}
